// extracted by mini-css-extract-plugin
module.exports = {"paper":"PaperStyles_paper__3lOQV"};